import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import CaseStudies from "../components/CaseStudies";
import Process from "../components/Process";
import Testimonials from "../components/Testimonials";
import Insights from "../components/Insights";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="relative min-h-screen bg-[#FAFAF7] text-[#0A0A0A] overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <CaseStudies />
        <Process />
        <Testimonials />
        <Insights />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
